import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconChevronUp: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 0.45L9.5 4.95L8.45 6L5 2.55L1.55 6L0.5 4.95L5 0.45Z" />
    </svg>
  </IconStyled>
);

IconChevronUp.defaultProps = iconDefaultProps;
IconChevronUp.displayName = 'IconChevronUp';

export default IconChevronUp;
